import {Fragment, h} from 'preact';

export default function DeviceDetailsInfo({data}){
    return (
        <Fragment>
            {data.map(dataItem => (
                <div className={dataItem.additionalClass ? "row account-details__block-field " + dataItem.additionalClass : "row account-details__block-field" }>
                    <div className={dataItem.additionalClass ? "col col-12 col-lg-6 account-details__block-field-label " + dataItem.additionalClass : "col col-12 col-lg-6 account-details__block-field-label" }>
                        {dataItem.field}
                    </div>
                    <div className="col col-12 col-lg-6">
                        {dataItem.value}
                    </div>
                </div>
            ))}
        </Fragment>
    )
}
